<div class="annotation" [style.line-height]="element.annoteLineHeight ? element.annoteLineHeight : 1">
    <div *ngIf="element.text" class="annotation--symbol">
        <element-render-text [element]="element.text" data-ui-name="Element render text" data-ui-component="element-render-annotation" data-testid="element-render-annotation-element-render-text"></element-render-text>
    </div>
    <div 
        *ngIf="element.annotation" 
        class="annotation-text-container"
        [class.is-left-align]="isLeftAlign()"
        [class.is-right-align]="isRightAlign()"
        [class.is-constrained-width]="element.isConstrainedWidth"
    >
        <div class="annotation-text">
            <markdown-inline [input]="element.annotation" data-ui-name="Markdown inline" data-ui-component="element-render-annotation" data-testid="element-render-annotation-markdown-inline"></markdown-inline>
        </div>
    </div>
</div>
